const W2HelpData = [
  {
    box: 'a',
    title: "Employee's Social Security Number (SSN)",
    keywords: [
      'Employee',
      'Employee\'s',
      'Social',
      'Security',
      'Number',
      'SSN',
    ],
    details: ["Your Employee's SSN is 9 digits, written ### - ## - ####. If your employee has applied but not received a SSN yet, enter zeros (000-00-0000). When the employee receives their social security card, file Form W-2c to correct your previous report."],
  },
  {
    box: 'b',
    title: 'Employer Identification Number (EIN)',
    keywords: [
      'Employer',
      'Identification',
      'Number',
      'EIN',
    ],
    details: ['Your IRS-assigned EIN is nine digits (## - #######). You used this on your federal employment tax returns. If you do not have an EIN when filing Form W-2, enter "Applied For" in box b to indicate an EIN was applied for; do not use your SSN. You can get an EIN online at www.IRS.gov/EIN'],
  },
  {
    box: 'c',
    title: "Employer's name, address, and ZIP code",
    keywords: [
      'Employer\'s',
      'Employer',
      'Name',
      'Address',
      'Zip',
      'Code',
      'Phone',
      'City',
      'State',
    ],
    details: ["This is the employer's legal address, which may not be the same as an employee's work address."],
  },
  {
    box: 'd',
    title: 'Control Number (optional)',
    keywords: [
      'Control',
      'Number',
    ],
    details: ['Some payroll departments use an internal control number to identify individual W-2 forms. You do not have to fill this box if you do not use control numbers.'],
  },
  {
    box: 'e',
    title: "Employee's name, address, and ZIP code",
    keywords: [
      'Employee',
      'Employee\'s',
      'Name',
      'Address',
      'Zip',
      'Code',
      'Phone',
      'City',
      'State',
    ],
    details: ["This is the employee's legal name and the address on file for tax purposes. The employee's name should match the name on file for their SSN (first name, middle initial, last name). If the full name does not fit in the space allowed on the form, you may show the first and middle name initials and the full last name.", "The employee's address can be a P.O. box number if needed. For a foreign address, give the information in the following order: city, province, or state, and country. Follow the country's practice for entering the postal code. Do not abbreviate the country name."],
  },
  {
    box: '1',
    title: 'Wages, tips, other compensation',
    keywords: [
      '1',
      'box 1',
      'Wages',
      'Tips',
      'Other',
      'compensation',
    ],
    details: ['Include everything the employee was paid - wages, tips, bonuses, commission - during the current tax year. Do not include contributions to retirement plans. This number can be less than the sum of boxes 2 and 3.'],
  },
  {
    box: '2',
    title: 'Federal income tax withheld',
    keywords: [
      '2',
      'box 2',
      'Federal',
      'Income',
      'withheld',
      'Tax',
    ],
    details: ['The federal income tax withheld during the tax year is based on exemptions the employee chose for the W-4 form and other withholdings.'],
  },
  {
    box: '3',
    title: 'Social security wages',
    keywords: [
      '3',
      'box 3',
      'wages',
      'Security',
      'Social',
    ],
    details: ['These are the employee’s wages that are subject to the Social Security tax, excluding tips. The maximum for social security wages for 2022 is $147,000. The total of boxes 3 and 7 cannot exceed this maximum.'],
  },
  {
    box: '4',
    title: 'Social security tax withheld',
    keywords: [
      '4',
      'box 4',
      'Social',
      'Security',
      'Tax',
      'withheld',
    ],
    details: ['Show the total employee social security tax (not your share) withheld. This tax is calculated on a 6.2% flat rate, including social security tips. To calculate box 4, add the values of box 3 and 7 together, and then multiply the sum by 6.2% (i.e. x0.062). For 2022, this amount cannot exceed $9,114.00 ($147,000 x 6.2%).'],
  },
  {
    box: '5',
    title: 'Medicare wages and tips',
    keywords: [
      '5',
      'box 5',
      'Medicare',
      'Wages',
      'tips',
    ],
    details: ['Enter the total Medicare wages and tips in box 5. The wages and tips subject to Medicare tax are the same as those subject to social security tax (boxes 3 and 7) except the $147,000 limit does not apply for Medicare tax. If the amount of wages paid was $147,000 or less, the amounts entered in boxes 3 and 5 will be the same. If the amount of wages paid was more than $147,000, you would enter $147,000 for box 3, and enter the full amount in box 5.'],
  },
  {
    box: '6',
    title: 'Medicare tax withheld',
    keywords: [
      '6',
      'box 6',
      'Medicare',
      'Tax',
      'Withheld',
    ],
    details: ['This tax is calculated on a 1.45% flat rate. To calculate box 6, multiply box 5 by 1.45% (i.e x0.0145) and add any additional Medicare taxes. There is an additional withholding percentage above a certain income level. The IRS explains it here: www.IRS.gov/ADMT'],
  },
  {
    box: '7',
    title: 'Social security tips',
    keywords: [
      '7',
      'box 7',
      'Social',
      'Security',
      'tips',
    ],
    details: ['This is the tips that the employee reported to the employer. Employees must report this if they earn over $20 in tips per month. In 2022 the maximum for social security wages and tips is $147,000. The total of boxes 3 and 7 cannot exceed this maximum.'],
  },
  {
    box: '8',
    title: 'Allocated tips',
    keywords: [
      '8',
      'box 8',
      'Allocated',
      'tips',
    ],
    details: ['If you operate a large food or beverage establishment, show the tips allocated to the employee. Do not include this amount in boxes 1, 3, 5, or 7.'],
  },
  {
    box: '10',
    title: 'Dependent care benefits',
    keywords: [
      '10',
      'box 10',
      'Dependent',
      'Care',
      'benefits',
    ],
    details: ['Some employers pay for benefits such as child care for their employees. If this amount is less than $5,000, it is considered a non-taxable benefit. Report all amounts paid or incurred (regardless of any employee forfeitures), including those in excess of $5000. Include any amounts over $5,000 in boxes 1, 3, 5.'],
  },
  {
    box: '11',
    title: 'Nonqualified Plans',
    keywords: [
      '11',
      'box 11',
      'Nonqualified',
      'plans',
    ],
    details: ['The purpose of box 11 is for the SSA (Social Security Administration) to determine if any part of the amount reported in box 1 or boxes 3 and/or 5 was earned in a prior year. Nonqualified plans include other tax-deferred, employer-sponsored plans like deferred compensation, executive bonus, group carve-out plans or split-dollar life insurance.'],
  },
  {
    box: '12',
    title: 'Codes',
    keywords: [
      '12',
      'box 12',
      'See',
      'Instructions',
    ],
    details: ['The IRS instructions designate codes A through HH for use in box 12. For example, enter code D for elective deferrals for 401(K) and DD for employer-sponsored health coverage. Include a maximum of 4 items, and use a separate W-2 if there are more. See the full list of codes on page 30 of the IRS Instructions (https://www.irs.gov/pub/irs-pdf/iw2w3.pdf).'],
  },
  {
    box: '13',
    title: 'Statutory employee, retirement plan, third-party sick pay',
    keywords: [
      '13',
      'box 13',
      'Statutory',
      'Employee',
      'Retirement',
      'Plan',
      'third',
      'Third-party',
      'Party',
      'Sick',
      'pay',
    ],
    details: ['Check all boxes that apply to the employee. Statutory employees pay social security and medicare taxes, but no federal income tax.'],
  },
  {
    box: '14',
    title: 'Other',
    keywords: [
      '14',
      'box 14',
      'other',
    ],
    details: ["This covers additional taxes or deductions that are not reported elsewhere, like state disability insurance taxes withheld, union dues, health insurance premiums deducted and nontaxable income.  If you included 100% of a vehicle's annual lease value in the employee's income, it also must be reported here or on a separate statement to your employees."],
  },
  {
    box: '15',
    title: "Employer's state id number",
    keywords: [
      '15',
      'box 15',
      'Employer\'s',
      'Employer',
      'State',
      'Id',
      'number',
    ],
    details: ['Enter the two-letter abbreviation for the name of the state or territory being reported. Also, enter your state or territory  assigned ID number. If the employee has tax withheld in multiple states, more than one box will be filled. However, if a W-3 will be submitted with this form that contains wage and income tax information from more than one state or territory, enter an "X" under "state" and do not enter any state or territory ID number.'],
  },
  {
    box: '16',
    title: 'State wages, tips, etc',
    keywords: [
      '16',
      'box 16',
      'State',
      'Wages',
      'Tips',
      'etc',
    ],
    details: ['Include everything the employee was paid - wages, tips, bonuses, commission - during the current tax year subject to state taxes. This may be the same number in box 1.'],
  },
  {
    box: '17',
    title: 'State income tax',
    keywords: [
      '17',
      'box 17',
      'State',
      'Income',
      'tax',
    ],
    details: ['This shows the amount of state income taxes withheld with respect to box 16. This number can be checked if the state has a flat tax rate by multiplying the tax rate by box 16.'],
  },
  {
    box: '18',
    title: 'Local wages, tips, etc',
    keywords: [
      '18',
      'box 18',
      'Local',
      'Wages',
      'Wage',
      'Tips',
      'Tip',
      'etc',
    ],
    details: ["This is the employee's locally taxable gross pay. This may be the same as box 1 or 16."],
  },
  {
    box: '19',
    title: 'Local income tax',
    keywords: [
      '19',
      'box 19',
      'Local',
      'Income',
      'tax',
    ],
    details: ["If the employee has wages that are withheld in more than two states or localities, the employer will give multiple W-2's."],
  },
  {
    box: '20',
    title: 'Locality name',
    keywords: [
      '20',
      'box 20',
      'Locality',
      'name',
    ],
    details: ['This is the name of the local, city or other state tax being reported in box 19.'],
  },
];

export default W2HelpData;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/HelpData/W2HelpData.js